import React from "react";
import Card from "components/card";
import Button from "components/button";
import {
  Gift,
  Trophy,
  ShoppingBag,
  Coffee,
  Plane,
  Ticket,
  Sparkles,
  Star,
} from "lucide-react";

const IconMap = {
  gift: Gift,
  trophy: Trophy,
  "shopping-bag": ShoppingBag,
  coffee: Coffee,
  plane: Plane,
  ticket: Ticket,
  sparkles: Sparkles,
  star: Star,
};

const Featured = ({
  title = "Featured Gift Deals",
  description = "Exclusive vouchers with special discounts up to 20% OFF!",
  highlight = "Redeem now with your Hyvid Points",
  badge = { label: "Limited Time" },
  stats = [
    { label: "Featured Deals", value: 4, icon: "gift" },
    { label: "Trending Now", value: 5, icon: "trophy" },
    { label: "Total Vouchers", value: 11, icon: "shopping-bag" },
  ],
  gradient = "from-emerald-600 via-teal-600 to-purple-600",
  onBrowseAll,
}) => {

  return (
    <Card className={`relative overflow-hidden text-white bg-gradient-to-r ${gradient} rounded-xl border-0 flex flex-col gap-6`}>
      <div className="absolute inset-0 overflow-hidden">
        <div
          className="absolute -top-10 -right-10 w-40 h-40 bg-white/10 rounded-full blur-2xl"
          style={{ transform: "scale(1.17) rotate(155deg)" }}
        />
        <div
          className="absolute -bottom-10 -left-10 w-60 h-60 bg-purple-400/20 rounded-full blur-3xl"
          style={{ transform: "scale(1.1) rotate(272deg)" }}
        />
      </div>

      <div className="relative z-10 p-8 pb-6">
        <div className="grid md:grid-cols-2 gap-6 items-center">
          <div className="space-y-4">
            <div className="opacity-100 transform-none">
              <div className="flex items-center gap-2 mb-2">
                <Sparkles className="w-8 h-8 text-yellow-300" />
                <span className="inline-flex items-center justify-center rounded-lg text-xs font-medium w-fit px-3 py-1 bg-yellow-400 text-yellow-900 border-0">
                  {badge.label}
                </span>
              </div>
              <h2 className="text-[32px] font-bold leading-tight">{title}</h2>
              <p className="text-[16px] opacity-90">
                {description} <br />
                <span className="text-yellow-300 font-medium">{highlight}</span>
              </p>
            </div>

            <div className="flex flex-wrap gap-3">
              {stats.map((stat) => {
                const StatIcon = IconMap[stat.icon];
                return (
                  <div
                    key={stat.label}
                    className="bg-white/20 backdrop-blur-sm rounded-lg px-4 py-2 flex items-center gap-2"
                  >
                    {StatIcon && <StatIcon className="w-5 h-5" />}
                    <div>
                      <p className="text-[10px] opacity-80">{stat.label}</p>
                      <p className="font-bold text-[16px]">{stat.value}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="relative">
            <div className="relative opacity-100 transform-none">
              <div className="flex items-center justify-center -translate-y-[9.5px] -rotate-[3.58deg]">
                <div className="relative">
                  <Trophy className="w-32 h-32 opacity-90 drop-shadow-2xl" />

                  <div className="absolute inset-0 flex items-center justify-center scale-[1.18]">
                    <Sparkles className="w-12 h-12 text-yellow-300" />
                  </div>
                </div>
              </div>

              <div className="absolute top-0 right-0 -translate-x-1 -translate-y-6">
                <div className="bg-white/30 backdrop-blur-sm p-3 rounded-full">
                  <Coffee className="w-6 h-6" />
                </div>
              </div>

              <div className="absolute bottom-0 left-0 translate-x-[-40px] translate-y-[6px]">
                <div className="bg-white/30 backdrop-blur-sm p-3 rounded-full">
                  <ShoppingBag className="w-6 h-6" />
                </div>
              </div>

              <div className="absolute top-1/2 left-0 -translate-y-1/2 -translate-x-8 rotate-[250deg]">
                <div className="bg-white/30 backdrop-blur-sm p-3 rounded-full">
                  <Plane className="w-6 h-6" />
                </div>
              </div>

              <div className="absolute top-1/2 right-0 -translate-y-1/2 translate-x-1 rotate-[-20deg]">
                <div className="bg-white/30 backdrop-blur-sm p-3 rounded-full">
                  <Ticket className="w-6 h-6" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-6 pt-6 border-t border-white/20 opacity-100 transform-none">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-[14px] opacity-90 flex items-center gap-2">
              <Star className="w-4 h-4 fill-yellow-300 text-yellow-300" />
              Don't miss out on these exclusive rewards!
            </p>
            <Button
              onClick={onBrowseAll}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm transition-all shrink-0 h-9 py-2 bg-white text-emerald-600 hover:bg-gray-100 font-medium px-6"
            >
              Browse All Deals 
              <div className="ml-2">→</div>
            </Button>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default Featured;
